import OptionLogo200 from "@/assets/imgs/rachman-sons-logo-gold-200h.webp"
import OptionLogo400 from "@/assets/imgs/rachman-sons-logo-gold-400h.webp"
import OptionLogoWhite200 from "@/assets/imgs/dsds-logo-white-200h.webp"
import OptionLogoWhite400 from "@/assets/imgs/dsds-logo-white-400h.webp"

const MainLogo = ({ isWhite = false, onLoadingPage = false }) => {
  return (
    onLoadingPage ?
      <img
        src={OptionLogo200}
        srcSet={`${OptionLogo200} 158w, ${OptionLogo400} 316w`}
        sizes="(max-width: 640px) 120px, (max-width: 768px) 150px, (max-width: 1024px) 180px, 200px"
        width="316"
        height="400"
        loading="eager"
        decoding="async"
        fetchpriority="high"
        alt="Rachman and Sons logo"
        className="mx-auto w-[120px] sm:w-[150px] md:w-[180px] lg:w-[200px]"
      />
      :
      <img
        src={isWhite ? OptionLogoWhite200 : OptionLogo200}
        srcSet={`${isWhite ? OptionLogoWhite200 : OptionLogo200} 158w, ${isWhite ? OptionLogoWhite400 : OptionLogo400} 316w`}
        sizes="20vw"
        loading="eager"
        decoding="async"
        fetchpriority="high"
        className="h-full w-auto object-contain"
        alt="DSDS logo"
      />
  )
}

export default MainLogo